<template lang="pug">
  el-container(id="PrivilegeEdit-container")
    el-dialog(id="PrivilegeEdit-dialogWrapper" :visible.sync="mutableEditDialogVisible", fullscreen=false, :title="$t('Edit privilege')", :before-close="beforeCloseHandler", :close-on-click-modal="false", append-to-body)
      el-form(
        id="PrivilegeEdit-form",
        :model="privilegeData",
        :rules="rules",
        ref="privilegeForm",
        label-width="180px",
        status-icon=true,
        :size="uxParam('formSize')",
        v-loading="loading",
      )
        el-form-item(:label="$t('Entity')", prop="entity")
          el-input(id="PrivilegeEdit-formEntityInput" v-model="privilegeData.entity")
        el-form-item(:label="$t('Action')", prop="action")
          el-input(id="PrivilegeEdit-formActionInput" v-model="privilegeData.action")
        el-form-item(:label="$t('Method')", prop="method")
          el-select.el-select-width-100(id="PrivilegeEdit-formMethodSelect" v-model="privilegeData.method")
            el-option(
              v-for="item in ['GET', 'POST', 'PUT', 'PATCH', 'DELETE']",
              :key="item",
              :label="item",
              :value="item",
              :id="'PrivilegeEdit-formOption' + item"
            )
        el-form-item(:label="$t('Description')", prop="description")
          el-input(id="PrivilegeEdit-formDescriptionInput" type="textarea", v-model="privilegeData.description")
        el-form-item(:label="$t('Roles')", prop="RoleIds")
          el-select.el-select-width-100(id="PrivilegeEdit-formRolesSelect" v-model='privilegeData.RoleIds', multiple)
            el-option(
              v-for="item in roleList",
              :key="item.id",
              :label="item.name",
              :value="item.id",
              :id="'PrivilegeEdit-formOption' + item.id"
            )
      .dialog-footer(slot="footer")
        el-button(
          id="PrivilegeEdit-formSubmitButton",
          type="primary",
          @click="submitForm('privilegeForm')"
          :circle="uxParam('buttonCircle')",
          :round="uxParam('buttonRound')",
          :plain="uxParam('buttonPlain')",
          :disabled="loading"
        ) {{$t('Save')}}
        el-button(
          id="PrivilegeEdit-formCancelButton",
          @click='mutableEditDialogVisible = false'
          :circle="uxParam('buttonCircle')",
          :round="uxParam('buttonRound')",
          :plain="uxParam('buttonPlain')"
        ) {{$t('Cancel')}}
</template>

<script>

export default {
  props: {
    'privilegeId': {
      required: true
    },
    'editDialogVisible': {
      required: true
    }
  },
  data () {
    return {
      loading: true,
      privilegeData: {
        id: 0,
        entity: '',
        action: '',
        method: null,
        Roles: [],
        RoleIds: []
      },
      roleList: [],
      rules: {
        entity: [
          { required: true, message: this.$t('Please enter privilege entity'), trigger: 'blur' }
        ],
        action: [
          { required: true, message: this.$t('Please enter privilege action'), trigger: 'blur' }
        ],
        method: [
          { required: true, message: this.$t('Please select method'), trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    privilegeId: async function (newVal, oldVal) {
      this.loading = true
      this.privilegeData = {
        id: 0,
        entity: '',
        action: '',
        method: null,
        Roles: [],
        RoleIds: []
      }

      this.roleList = await this.$store.dispatch('Role/getRoles')

      this.$nextTick(function () {
        this.$refs['privilegeForm'].resetFields()
      })

      if (this.privilegeId !== null && this.privilegeId !== 0) {
        let privilegeData = await this.$store.dispatch('Privilege/getPrivilegeData', {
          data: {
            privilegeId: this.privilegeId
          }
        })
        this.privilegeData = JSON.parse(JSON.stringify(privilegeData))
      }

      this.loading = false
    }
  },
  methods: {
    async submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(this.privilegeId === 0 ? 'Privilege/createPrivilegeData' : 'Privilege/updatePrivilegeData', {
            data: JSON.parse(JSON.stringify(this.privilegeData))
          })
            .then(response => {
              this.mutableEditDialogVisible = false
              this.loading = false
            })
            .catch(error => {
              console.log(error.response.status)
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    beforeCloseHandler: function (done) {
      done()
    }
  },
  computed: {
    mutableEditDialogVisible: {
      get: function () {
        return this.editDialogVisible
      },
      set: function (value) {
        this.$emit('closeEditDialog', value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Privilege/PrivilegeEdit.vue